export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_PERMISSION = "LOGIN_PERMISSION"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const RESET_LOGIN_FLAG = "RESET_LOGIN_FLAG"
export const GET_IP = "GET_IP"
export const GET_IP_SUCCESS = "GET_IP_SUCCESS"
export const GET_IP_ERROR = "GET_IP_ERROR"

export const LOGIN_USER_INFO = "LOGIN_USER_INFO"
